/* IGSHOP CUSTOM — mobile product gallery counter.

   The gallery itself is CSS scroll-snap; this only keeps the "2 / 6" readout in
   step with it. Deliberately no autoplay and no arrows: a product gallery that
   moves on its own slides away while a customer is inspecting the piece, and
   arrows duplicate the swipe they already have.

   Uses IntersectionObserver against the scroller rather than deriving an index
   from scrollLeft. Slides are narrower than the viewport so the next one peeks,
   and there are spacer pseudo-elements at each end, so any width-based maths
   would drift. Observing which slide is actually most visible is correct
   whatever the widths.

   The counter renders 1 / N server-side, so if this script fails the number is
   stale rather than the gallery being broken. */

(function () {
  'use strict';

  var gallery = document.querySelector('.bbc-pdp__gallery');
  var current = document.querySelector('[data-bbc-current]');
  if (!gallery || !current) return;

  var shots = Array.prototype.slice.call(gallery.querySelectorAll('.bbc-pdp__shot'));
  if (shots.length < 2) return;

  if (!('IntersectionObserver' in window)) return;

  var ratios = new Array(shots.length).fill(0);
  var shown = 1;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        ratios[shots.indexOf(entry.target)] = entry.intersectionRatio;
      });

      // The most visible slide is the one the reader considers current.
      var best = 0;
      for (var i = 1; i < ratios.length; i++) {
        if (ratios[i] > ratios[best]) best = i;
      }

      if (best + 1 === shown) return;
      shown = best + 1;
      current.textContent = shown;
    },
    {
      root: gallery,
      // Enough steps to resolve which of two part-visible slides leads.
      threshold: [0, 0.25, 0.5, 0.75, 1],
    }
  );

  shots.forEach(function (shot) {
    observer.observe(shot);
  });
})();
